import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme, { open } = {}) => ({
  button: {
    backgroundColor: !open ? '#F4F4F4' : 'white',
    borderRadius: 4,
    height: 24,
    minWidth: 20,
    padding: 0,
    '& svg': {
      height: 24,
      width: 24,
    },
  },
}));
